import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import { truncate } from 'flarum/common/utils/string';
import truncateHtml from '../utils/truncateHtml';
export default class Excerpt extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "post", void 0);
    _defineProperty(this, "length", void 0);
    _defineProperty(this, "richExcerpt", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.post = this.attrs.post;
    this.length = this.attrs.length;
    this.richExcerpt = this.attrs.richExcerpt;
  }
  view() {
    return m("div", {
      className: "Synopsis-excerpt"
    }, this.getContent());
  }
  getContent() {
    var _this$contentPlain;
    if (this.richExcerpt) {
      var _this$contentRich;
      return m.trust(truncateHtml((_this$contentRich = this.contentRich()) != null ? _this$contentRich : '', this.length));
    }
    return truncate((_this$contentPlain = this.contentPlain()) != null ? _this$contentPlain : '', this.length);
  }
  contentRich() {
    return this.post.contentHtml();
  }
  contentPlain() {
    return this.post.contentPlain();
  }
}
flarum.reg.add('fof-synopsis', 'forum/components/Excerpt', Excerpt);